import { createScopedEvent } from 'chimera/all/plugins/tracking/google/events/analytics/index'

/**
 * @param {object} Vue
 * @param {object} event
 * @param {object} event.scope
 * @param {string} event.elementId
 * @param {string} event.elementType
 * @param {object} event.metadata
 */
export function trackClick(
  Vue,
  { scope, elementId, elementType, metadata = {} } = {},
) {
  // Assert that our event is received correctly.
  if (elementId === undefined || elementType === undefined) {
    throw new TypeError(
      `Received click event with elementId ${elementId}, elementType ${elementType}`,
    )
  }

  // Google Analytics does not support nested objects, so we need to flatten the metadata.
  const mergedMetadata = Object.entries(metadata).reduce(
    (acc, [key, value]) => {
      const snakeCaseKey = key.replace(/([A-Z])/g, '_$1').toLowerCase()
      acc[`metadata/${snakeCaseKey}`] = value
      return acc
    },
    {},
  )

  Vue.$gtag.event(
    'click',
    createScopedEvent(scope, {
      element_id: elementId,
      element_type: elementType,
      ...mergedMetadata,
    }),
  )
}
